/* MARBELLA — fade-in editorial al hacer scroll.
   Se carga una sola vez aunque varias secciones lo referencien. */
(function () {
  if (window.__marbellaRevealReady) return;
  window.__marbellaRevealReady = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    if (el.dataset.revealBound === 'true') return;
    el.dataset.revealBound = 'true';
    if (reduce || !('IntersectionObserver' in window)) {
      el.classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    io.observe(el);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-marbella-reveal-item]').forEach(reveal);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();